import { render, staticRenderFns } from "./userView.vue?vue&type=template&id=664ce912&scoped=true"
import script from "./userView.vue?vue&type=script&lang=js"
export * from "./userView.vue?vue&type=script&lang=js"
import style0 from "./userView.vue?vue&type=style&index=0&id=664ce912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ce912",
  null
  
)

export default component.exports